import { FechaFunctionsService } from '@/utils/functions.service'
import { Component } from '@angular/core';
import { GeneralService } from '@services/general.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pedidos-hoy',
  templateUrl: './pedidos-hoy.component.html',
  styleUrls: ['./pedidos-hoy.component.scss']
})
export class PedidosHoyComponent {
  rowsHoy: Array<any>;
  rowsProcesados: Array<any>;
  isLoadingHoy: boolean = false;
  isLoadingProcesados: boolean = false;

  constructor(
    public generalService: GeneralService,
    private toastr: ToastrService,
    public FechaFunc: FechaFunctionsService) {
  }

  async ngOnInit() {
    this.getDataHoy();
    this.getData();
  }

  async getDataHoy() {
    try {
      this.isLoadingHoy = true
      let res = await this.generalService.getListar(`pedido/hoy`)
      this.rowsHoy = res.data;
      this.isLoadingHoy = false
    } catch (error) {
      this.isLoadingHoy = false
    }
  }

  async getData() {
    try {
      this.isLoadingProcesados = true
      let res = await this.generalService.getListar(`pedido/procesados`)
      this.rowsProcesados = res.data;
      this.isLoadingProcesados = false
    } catch (error) {
      this.isLoadingProcesados = false

    }
  }

}
